import defaultState from '../default';

const secondary = (params) => defaultState.secondary(params);

export default secondary;
